
import {
  Component,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TimezoneDialogComponent } from '../timezone-dialog/timezone-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { TimeZoneService } from '../../services/time-zone/time-zone.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-timezone-display',
        standalone: true,
imports: [MatIconModule],
    templateUrl: './timezone-display.component.html',
    styleUrl: './timezone-display.component.scss'
})
export class TimezoneDisplayComponent implements OnInit, OnDestroy {
  currentTime: string = '';
  timezone: string = '';
  interval: any;
  isBrowser: boolean;
  selectedTimezone: string = '';
  private subscription: Subscription | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private dialog: MatDialog,
    private timezoneService: TimeZoneService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  openTimezoneDialog(): void {
    if (!this.isBrowser) return;

    const dialogRef = this.dialog.open(TimezoneDialogComponent, {
      width: '400px',
      panelClass: ['buyer-theme'],
      data: {
        currentTimezone: this.selectedTimezone,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.timezoneService.setTimezone(result);
      }
    });
  }

  private updateTimeDisplay(): void {
    if (!this.isBrowser || !this.selectedTimezone) return;

    try {
      const date = new Date();
      this.currentTime = date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: this.selectedTimezone,
      });
      this.timezone = this.selectedTimezone.split('/').pop() || this.selectedTimezone;
    } catch (error) {
      console.error('Error updating timezone display:', error);
    }
  }

  ngOnInit(): void {
    if (!this.isBrowser) {
      this.timezone = 'UTC';
      this.currentTime = '--:--';
      return;
    }

    // Subscribe to timezone changes from the service
    this.subscription = this.timezoneService.timezoneChanged$.subscribe(
      (timezoneInfo) => {
        if (timezoneInfo) {
          this.selectedTimezone = timezoneInfo.ianaName;
          this.updateTimeDisplay();
        } else {
          // Fallback to browser timezone
          this.selectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          this.updateTimeDisplay();
        }
      }
    );

    // Update time every second
    this.interval = setInterval(() => {
      this.updateTimeDisplay();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.isBrowser && this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.subscription?.unsubscribe();
  }
}
